import type { ComponentType, ReactElement } from "react";

import {
  Sight,
  TimeSeries,
  Seiches,
  Wind,
  HTML,
  HighCharts,
  Radar,
  ImageSeries,
  Image,
  Link,
  LinkSeries,
  IFrame,
  TextCode,
  Text,
  Report,
  Probabilities,
  Map,
  RichText,
  EarlyWarningTable,
  InlinePDF,
  OpmetReport,
  Graph,
  ObservationsMap,
  ModelMap,
  MaritimeBroadcast,
  MaritimeForecast,
  MaritimeSeiches,
  TimeSeriesWidget,
} from "@/features/shared/widgets";

export type WidgetComponent = (props: unknown) => ReactElement;

type WidgetRendererMap = {
  // We allow any here becasue we don't know what the component props will be
  [key: string]: ComponentType<never>;
};

export const LEGACY_WIDGETS: WidgetRendererMap = {
  sight: Sight,
  seiches: Seiches,
  timeseries: TimeSeries,
  wind: Wind,
  highcharts: HighCharts,
  radar: Radar,
  image: Image,
  images: ImageSeries,
  link: Link,
  links: LinkSeries,
  iframe: IFrame,
  textcode: TextCode,
  text: Text,
  report: Report,
  probabilities: Probabilities,
  html: HTML,
  inline_pdf: InlinePDF,
};

export const WIDGETS: WidgetRendererMap = {
  map: Map,
  rich_text: RichText,
  line_graph: Graph,
  opmet_report: OpmetReport,
  early_warning_table: EarlyWarningTable,
  observations_map: ObservationsMap,
  model_map: ModelMap,
  maritime_broadcast: MaritimeBroadcast,
  maritime_forecast: MaritimeForecast,
  maritime_seiches: MaritimeSeiches,
  time_series: TimeSeriesWidget,
};
